<div class="notifications-dropdown">
  <button
    type="button"
    class="notifications-dropdown__trigger"
    (click)="toggle($event)"
    [attr.aria-expanded]="isOpen()"
    aria-haspopup="true"
  >
    <ui-icon
      name="icons:bell"
      size="34px"
      [color]="unreadCount() > 0 ? '#4CB050' : '#A0A0A0'"
    ></ui-icon>
    @if (unreadCount() > 0) {
    <span class="notifications-dropdown__badge">{{ badgeText() }}</span>
    }
  </button>

  @if (isOpen()) {
  <div class="notifications-dropdown-panel" (click)="$event.stopPropagation()">
    <div class="notifications-dropdown-panel__header">
      <span class="notifications-dropdown-panel__title">
        {{ 'MOBILE_MENU_NOTIFICATIONS' | localization }}
      </span>
      <span class="notifications-dropdown-panel__count">{{ total() }}</span>
    </div>

    <div class="notifications-dropdown-panel__list" (scroll)="onListScroll($event)">
      @if (notifications().length) { @for (notification of notifications(); track notification.id) {
      <pkp-notification-card
        [notification]="notification"
        (selected)="onNotificationSelected($event)"
      />
      } @if (loading()) {
      <div class="flex justify-center py-2">
        <ui-loading size="20px"></ui-loading>
      </div>
      } } @else {
      <p class="notifications-dropdown-panel__empty">
        {{ 'NOTIFICATIONS_EMPTY' | localization }}
      </p>
      }
    </div>
  </div>
  }
</div>
